import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StagiaireActionsCtx = createContext({
    data: null,
    refresh: () => {},
});

export function StagiaireActionsProvider({ children }) {
    const [data, setData] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const { data: payload } = await api.get("/stagiaire/action-items");
            setData(payload);
        } catch {
            // Fail silently — the badges just won't appear.
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <StagiaireActionsCtx.Provider value={{ data, refresh }}>
            {children}
        </StagiaireActionsCtx.Provider>
    );
}

export function useStagiaireActions() {
    return useContext(StagiaireActionsCtx);
}
